import { defineMessage } from 'services/localization';

export const messages = {
    account: defineMessage('account'),
    amount: defineMessage('amount_currency'),
    budgetName: defineMessage('budget_name'),
    budgetPeriod: defineMessage('budget_period_1'),
    description: defineMessage('the_following_budgets_w_pproval_of_this_request_1'),
    fullPeriod: defineMessage('full_period'),
    remainingBudget: defineMessage('remaining_budget_currency_1'),
    status: defineMessage('status_1'),
    ytd: defineMessage('ytd'),
};
